import { BaseError, } from './BaseError';
/**
 * Generic error class.
 *
 * A generic error object without a specific purpose with all base properties.
 */
export class GenericError extends BaseError {
    static className = 'GenericError';
    constructor(props) {
        super(props);
    }
    /**
     * Create a new GenericError from a Javascript Error object.
     *
     * @param e The Javascript Error object
     * @param source Additional error source to enrich the error with
     */
    static fromError(e, source) {
        const error = new GenericError({ message: e.message, source });
        error.stack = e.stack;
        return error;
    }
    /**
     * Creates a new GenericError from an unknown error.
     *
     * @param e The unknown error
     * @param source The error source in case the error itself does not provide it. Will never overwrite an existing error source!
     */
    static fromUnknown(e, source) {
        if (e instanceof GenericError) {
            if (!e.source && source) {
                e.source = source;
            }
            return e;
        }
        return GenericError.fromError(e instanceof Error
            ? e
            : new Error(typeof e === 'string' ? e : 'Unknown error'), source);
    }
    getTranslatedType(t) {
        return t(`common:errors.${this.className}.type`);
    }
    getTranslatedMessage(t) {
        return t(`common:errors.${this.className}.message`);
    }
}
